// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__3Lmg9","tagButton":"styles_tagButton__YtMtE","icon":"styles_icon__3cmVT","label":"styles_label__4qwyX"};